var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-megamenu-outer-container"},[_c('div',{staticClass:"card-megamenu-container"},_vm._l((_vm.cards),function(card){return _c('AtomsMegaMenuCard',{key:card.mainRef,attrs:{"cardData":{
        mediaPath: card.media,
        altText: card.mainDesc,
        text: card.mainDesc,
        url: _vm.formatUrl(card.mainRef)
      }}})}),1),_vm._v(" "),_c('div',{staticClass:"megamenu-link-container"},[_c('a',{staticClass:"megamenu-link",attrs:{"href":_vm.allServicesUrl}},[_vm._v(_vm._s(_vm.translate('view_all_services')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }